import { render } from "./inputModal.vue?vue&type=template&id=1829dde1&ts=true"
import script from "./inputModal.vue?vue&type=script&lang=ts"
export * from "./inputModal.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__